import { useListHubDelivery } from "hooks/hub-delivery/useHubDelivery";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const HubDeliverySelect = ({
  isDisabled,
  idDefault,
  setValue,
  value,
  fieldName,
  paramsColumnFilter,
  ...props
}) => {
  const { t } = useTranslation(["hub"]);

  const [hubDeliveriesParams, setHubDeliveriesParams] = useState({
    sizePerPage: 1000,
    page: 1,
    sort: "-maker_date",
    columnFilter: {
      "filter[record_status]": "O",
    },
    keywords: "",
    fields: "",
    expand: "transport,bus",
    run: false,
  });

  const { data: hubDeliveries, refetch: refetchHubDeliveries } =
    useListHubDelivery({
      key: `hub-delivery-select-${fieldName}`,
      enabled: false,
      params: hubDeliveriesParams,
    });

  useEffect(() => {
    if (hubDeliveriesParams && hubDeliveriesParams?.run) {
      refetchHubDeliveries();
    }
  }, [JSON.stringify(hubDeliveriesParams)]);

  useEffect(() => {
    if (paramsColumnFilter) {
      setHubDeliveriesParams(prev => {
        return {
          ...prev,
          columnFilter: {
            ...prev.columnFilter,
            ...paramsColumnFilter,
          },
          run: true,
        };
      });
    }
  }, [JSON.stringify(paramsColumnFilter)]);

  const options = useMemo(() => {
    return (
      hubDeliveries?.items?.map(item => {
        const transportData = item?.transport;
        const busData = item?.bus;

        const isChanhXe = transportData?.shipping_type === 3 ? true : false; // Chành xe
        const finalBusData = isChanhXe
          ? {
              value: busData?.id,
              label: busData?.name,
            }
          : {
              value: transportData?.id,
              label: transportData?.name,
            };
        return {
          transport: transportData,
          value: item.transport_id || item.bus_id,
          label: isChanhXe ? "Chành xe" : "Đơn vị vận chuyển",
          busData: finalBusData,
          shippingType: transportData?.shipping_type,
        };
      }) || []
    );
  }, [hubDeliveries?.items]);

  const defaultValue = useMemo(() => {
    if (value) {
      return value;
    }
    const optionSelect = options?.find(o => o.value === idDefault);
    if (optionSelect && fieldName) {
      setValue(fieldName, optionSelect);
    }
    return optionSelect;
  }, [options, idDefault, value]);

  useEffect(() => {
    if (options?.length > 0) {
      setValue(fieldName, options[0]);
    }
  }, [options]);

  return (
    <Select
      {...props}
      value={defaultValue}
      placeholder={t("placeholder.select", {
        title: "Đơn vị vận chuyển",
      })}
      options={options}
      classNamePrefix="select2-selection"
      isDisabled={isDisabled}
    />
  );
};
export default HubDeliverySelect;
